export default "/images/vendor/flag-icon-css/flags/1x1/am.svg?36fc7db319e532bff785a981db0c3334";